/* eslint-disable */
import { globalVars } from './globalVars';
import { VirtualNode, VirtualProps } from './virtual';
import { PLATFORM, STYLE_ATTRS, ACTION_ATTRS, FLEX_MAP, HEX_MAP } from './conf';

const { isMobile } = globalVars;
const SCRIPT_REG = /<script>([\s\S]*?)<\/script>/i;

// 提取出xml结构内容和script脚本内容
export function parseMsgContent(content) {
  let xml = '';
  let script = '';

  // 判断是否包含script脚本内容
  if (SCRIPT_REG.test(content)) {
    const result = SCRIPT_REG.exec(content);
    if (result.length) {
      script = result[1];
    }
    xml = content.replace(SCRIPT_REG, '').trim();
  } else {
    xml = content.trim();
  }

  return [xml, script];
}

export function parseMsgXML(content) {
  if (window.DOMParser) {
    try {
      const parser = new DOMParser();
      const xmlDocument = parser.parseFromString(
        SCRIPT_REG.test(content) ? content.replace(SCRIPT_REG, '').trim() : content.trim(),
        'text/xml',
      );
      return xmlDocument;
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
}

/**
 * 转换为前端识别长度单位
 * @param {string|number} value 长度值，格式200
 */
export function computeUnit(value) {
  const num = +value;
  if (!isNaN(num)) {
    if (num === 0) return '0px';
    if (num === 1) return `${num}px`;

    if (isMobile) {
      // 移动端 - 转换为vw视口单位，设计稿以iPhone6 375px为标准设计
      // return `${(num / (375 * 2)) * 100}vw`;
      // 移动端 - 直接按照设计图的尺寸1/2返回
      return `${num / 2}px`;
    }
    // PC端 - 直接按照设计图的尺寸1/2返回
    return `${num / 2}px`;
  }
  return '0px';
}

/**
 * 转换为前端识别颜色值
 * @param {string} value 颜色值，格式#FFFFFFFF
 * @return {string} rgba格式颜色值
 */
export function computeColor(value) {
  function convertHToD(num) {
    const arr = Array.from(num);
    return Array.from(arr).reduce((total, current, index) => total + HEX_MAP[current] * Math.pow(16, arr.length - index - 1), 0);
  }

  const alpha = convertHToD(value.slice(1, 3)) / 255;
  const red = convertHToD(value.slice(3, 5));
  const green = convertHToD(value.slice(5, 7));
  const blue = convertHToD(value.slice(7, 9));

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

function camelToPrefix(str) {
  str = str.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);

  if (str.slice(0, 1) === '_') {
    str = str.slice(1);
  }

  return str;
}

/**
 * 获取设置html元素的style字符串
 * @param {Object} style 样式对象
 */
export function getHtmlStyle(style) {
  const ret = [];

  for (const key in style) {
    ret.push(`${camelToPrefix(key)}: ${style[key]}`);
  }

  return ret.join(';');
}

export function translateXMLToStyle(name, value) {
  const ret = {};
  let arr;

  function getFlexValue(type, value) {
    return FLEX_MAP[type][value];
  }

  switch (name) {
    case 'width':
      if (value === '-1') {
        ret.display = 'block';
        ret.width = '100%';
      } else if (value === '-2') {
        ret.display = 'inline-block';
        ret.width = 'auto';
      } else {
        ret.display = 'block';
        ret.width = computeUnit(value);
      }
      break;
    case 'height':
      if (value === '-1') {
        ret.height = '100%';
      } else if (value === '-2') {
        ret.height = 'auto';
      } else {
        ret.height = computeUnit(value);
      }
      break;

    case 'paddingLeft':
    case 'paddingRight':
    case 'paddingTop':
    case 'paddingBottom':
    case 'marginLeft':
    case 'marginRight':
    case 'marginTop':
    case 'marginBottom':
      ret[name] = computeUnit(value);
      break;
    case 'padding':
    case 'margin':
      arr = value.split(',');
      // 转换顺序left-top-right-bottom 到 top-right-bottom-left
      const first = arr.shift();
      arr.push(first);
      ret[name] = arr.map(a => computeUnit(a)).join(' ');
      break;

    case 'gravity':
      ret.display = 'flex';
      arr = value.split('|');

      const H = ['left', 'right', 'centerHorizontal'];
      const V = ['top', 'bottom', 'centerVertical'];

      if (arr.length > 1) {
        const [first, second] = arr;
        ret.justifyContent = getFlexValue('H', first);
        ret.alignItems = getFlexValue('V', second);
      } else {
        const [one] = arr;
        if (~H.indexOf(one)) {
          ret.justifyContent = getFlexValue('H', one);
        }

        if (~V.indexOf(one)) {
          ret.alignItems = getFlexValue('V', one);
        }

        if (one === 'center') {
          ret.justifyContent = getFlexValue('H', 'centerHorizontal');
          ret.alignItems = getFlexValue('V', 'centerVertical');
        }
      }
      break;
    case 'weight':
      ret.flexGrow = Number(value);
      break;

    case 'background':
      ret.backgroundColor = computeColor(value);
      break;
    case 'alpha':
      ret.opacity = Number(value);
      break;
    case 'cornerRadius':
      ret.borderRadius = computeUnit(value);
      break;
    case 'borderWidth':
      ret.borderWidth = computeUnit(value);
      break;
    case 'borderColor':
      ret.borderColor = computeColor(value);
      break;
    case 'borderStyle':
      ret.borderStyle = value;
      break;
    case 'hidden':
      const hidden = translateXMLToAttribute(value);
      ret.display = hidden ? 'none' : 'block';
      break;
        // no default
  }

  return ret;
}

export function translateXMLToAction(name, value, action) {
  if (name === 'action') {
    action.actionCmd = value;
  } else if (name === 'actionData') {
    action.actionData = value;
  } else if (name === 'click') { // click="send" 之类的事件解析
    action.type = name;
    action.fun = value;
  }

  return action;
}

export function translateXMLToAttribute(value) {
  // 需要处理字符串true和false为布尔值
  if (value === 'true') return true;
  if (value === 'false') return false;

  return value;
}

/**
 * 翻译xml节点为VirtualDOM节点
 * @param {Element} xmlElement xml节点
 * @param {VirtualNode} virtualNode 虚拟DOM节点
 */
export function translateXMLToVirtualNode(xmlElement, virtualNode) {
  const { attributes, children } = xmlElement;
  const { props } = virtualNode;

  for (let i = 0, len = attributes.length; i < len; i++) {
    const attribute = attributes[i];
    let { name } = attribute;

    // 属性包含平台信息，需要过滤掉在其他平台使用的属性
    if (name.indexOf('.')) {
      const arr = name.split('.');
      if (arr.length === 2) {
        if (arr[1] === PLATFORM.web) {
          name = arr[0];
        } else {
          continue;
        }
      }
    }

    // name属性单独设置
    // platform属性单独设置
    if (name === 'name' || name === 'platform') {
      props[name] = attribute.value;
      continue;
    }

    // 样式属性需要转换后设置
    if (STYLE_ATTRS.indexOf(name) !== -1) {
      props.style = Object.assign(props.style, translateXMLToStyle(name, attribute.value));
      continue;
    }

    // 动作属性需要转换后设置
    if (ACTION_ATTRS.indexOf(name) !== -1) {
      props.action = Object.assign(props.action, translateXMLToAction(name, attribute.value, props.action));
      continue;
    }

    // 其他属性保持不变
    props.attrs[name] = translateXMLToAttribute(attribute.value);
  }

  if (children && children.length) {
    for (let i = 0, len = children.length; i < len; i++) {
      const childElement = children[i];
      const childNode = new VirtualNode(childElement.tagName);
      translateXMLToVirtualNode(childElement, childNode);

      // 如果设置了平台可见属性platform，需要判断是否需要添加该节点
      if (childNode.props.platform && childNode.props.platform !== PLATFORM.web) {
        continue;
      }

      virtualNode.children.push(childNode);
    }
  }
}

/**
 * 翻译xml内容中为网页可以识别的VirtualDOM
 * @param {XMLDocument} xmlDoc xml对象
 * @return {VirtualNode} 虚拟DOM根节点
 */
export function translateXMLToVirtualDOM(xmlDoc) {
  const element = xmlDoc.querySelector('msg');
  const node = new VirtualNode('msg');

  translateXMLToVirtualNode(element, node);

  return node;
}
